import { head, imageCompressor } from 'helpers'
import s from './styles.module.scss'
import { useEffect, useState, useRef, useCallback } from 'react'
import { Alert, ImageTag, Input, Layouts, Loader, TextArea, UploadImages } from 'components'
import DashBoardNav from '../dashboardNav'
import { Link } from 'react-router-dom'
import * as api from 'api'

export default function Main() {
  const [bannerImages, setBannerImages] = useState([])
  const [bannerImagesUrls, setBannerImagesUrls] = useState([])
  const [oldBannerImagesRemoved, setOldBannerImagesRemoved] = useState([])
  const [oldBannerImagesUrls, setOldBannerImagesUrls] = useState([])
  const [link, setLink] = useState('')
  const [links, setLinks] = useState([])
  const [adImages, setAdImages] = useState([])
  const [adImagesData, setAdImagesData] = useState([]) // [{image: file, imageUrl: url, link: url}, ...]
  const [oldAdImagesRemoved, setOldAdImagesRemoved] = useState([])
  const [oldAdImagesData, setOldAdImagesData] = useState([]) // [{image: url, link: url}, ...]
  const [loadingStatus, setLoadingStatus] = useState('Loading...')
  const [loading, setLoading] = useState(false)
  const [isUploading, setIsUploading] = useState(false)
  const [uploadingProgress, setUploadingProgress] = useState(0)
  const [aboutUs, setAboutUs] = useState('')
  const [privacyPolicy, setPrivacyPolicy] = useState('')
  const [termsAndConditions, setTermsAndConditions] = useState('')
  const [phoneNo, setPhoneNo] = useState('')
  const [email, setEmail] = useState('')
  const [facebookLink, setFacebookLink] = useState('')
  const [whatsappLink, setWhatsappLink] = useState('')
  const [instagramLink, setInstagramLink] = useState('')
  const processing = useRef(false)

  useEffect(() => {
    head({ title: 'Dashboard Demographics | BCN' })
  }, [])

  const handleRemoveBannerImage = i => {
    let newSelectedImages = [...bannerImages]
    let newImageUrls = [...bannerImagesUrls]
    newSelectedImages.splice(i, 1)
    newImageUrls.splice(i, 1)
    URL.revokeObjectURL(bannerImagesUrls[i])
    setBannerImages(newSelectedImages)
    setBannerImagesUrls(newImageUrls)
  }

  const handleRemoveOldBannerImage = i => {
    let newImageUrls = [...oldBannerImagesUrls]
    let newRemovedImages = [...oldBannerImagesRemoved]
    newRemovedImages.push(oldBannerImagesUrls[i])
    setOldBannerImagesRemoved(newRemovedImages)
    newImageUrls.splice(i, 1)
    setOldBannerImagesUrls(newImageUrls)
  }

   const handleRemoveAdImage = i => {
    let newSelectedImages = [...adImages]
    let newImagesData = [...adImagesData]
    if (newImagesData[i]?.imageUrl) {
      URL.revokeObjectURL(newImagesData[i].imageUrl)
    }
    newSelectedImages.splice(i, 1)
    newImagesData.splice(i, 1)
    setAdImages(newSelectedImages)
    setAdImagesData(newImagesData)
  }

  const handleRemoveOldAdImage = i => {
    let newImagesData = [...oldAdImagesData]
    let newRemovedImages = [...oldAdImagesRemoved]
    if (newImagesData[i]?.image) {
      newRemovedImages.push(newImagesData[i].image)
    }
    setOldAdImagesRemoved(newRemovedImages)
    newImagesData.splice(i, 1)
    setOldAdImagesData(newImagesData)
  }

  const handleAdImageLinkChange = (index, link) => {
    let newImagesData = [...adImagesData]
    if (newImagesData[index]) {
      newImagesData[index] = { ...newImagesData[index], link }
      setAdImagesData(newImagesData)
    }
  }

  const handleOldAdImageLinkChange = (index, link) => {
    let newImagesData = [...oldAdImagesData]
    if (newImagesData[index]) {
      newImagesData[index] = { ...newImagesData[index], link }
      setOldAdImagesData(newImagesData)
    }
  }

  const handleBannerImagesChange = async e => {
    console.log('[DEBUG] Banner input change fired')
    setIsUploading(true)
    const files = Array.prototype.slice.call(e.target.files)
    console.log('[DEBUG] Banner files selected:', files?.map(f => f.name))

    if (files.length > 6 - (bannerImagesUrls.length + oldBannerImagesUrls.length)) {
      Alert.warn('Upto 6 images allowed')
      setIsUploading(false)
      return
    }

    setUploadingProgress(10)

    if (files.length > 0) {
      const newSelectedImages = bannerImages
      const newImageUrls = bannerImagesUrls
      setUploadingProgress(30)
      console.log('[DEBUG] Compressing banner files...')
      const compressedFiles = await imageCompressor(files, 'listing')
      console.log('[DEBUG] Banner files compressed:', compressedFiles?.map(f => f.name))
      setUploadingProgress(70)

      for (let i = 0; i < compressedFiles.length; i++) {
        const file = compressedFiles[i]
        const imageUrl = URL.createObjectURL(file)
        newSelectedImages.push(file)
        newImageUrls.push(imageUrl)
      }

      setBannerImages(newSelectedImages)
      setBannerImagesUrls(newImageUrls)
      console.log('[DEBUG] Banner state updated. Count:', newSelectedImages.length)
      setUploadingProgress(100)
      setIsUploading(false)
    }
  }

    const handleAdImagesChange = async e => {
    console.log('[DEBUG] Ad input change fired')
    setIsUploading(true)
    const files = Array.prototype.slice.call(e.target.files)
    console.log('[DEBUG] Ad files selected:', files?.map(f => f.name))

    if (files.length > 6 - (adImagesData.length + oldAdImagesData.length)) {
      Alert.warn('Upto 6 images allowed')
      setIsUploading(false)
      return
    }

    setUploadingProgress(10)

    if (files.length > 0) {
      const newSelectedImages = [...adImages]
      const newImagesData = [...adImagesData]
      setUploadingProgress(30)
      console.log('[DEBUG] Compressing ad files...')
      const compressedFiles = await imageCompressor(files, 'listing')
      console.log('[DEBUG] Ad files compressed:', compressedFiles?.map(f => f.name))
      setUploadingProgress(70)

      for (let i = 0; i < compressedFiles.length; i++) {
        const file = compressedFiles[i]
        const imageUrl = URL.createObjectURL(file)
        newSelectedImages.push(file)
        newImagesData.push({ image: file, imageUrl, link: '' })
      }

      setAdImages(newSelectedImages)
      setAdImagesData(newImagesData)
      console.log('[DEBUG] Ad images state updated. Count:', newSelectedImages.length)
      setUploadingProgress(100)
      setIsUploading(false)
    }
  }

  const getDemographics = useCallback(async () => {
    if (processing.current) return
    processing.current = true
    setLoading(true)

    const fetchDemographics = await api.admin.demographics.fetch({})

    if (fetchDemographics.code === 201) {
      let result = fetchDemographics.payload.demographics
      
      // Filter out invalid values
      const filterValidUrls = (arr) => {
        if (!Array.isArray(arr)) return []
        return arr.filter(item => 
          item && 
          typeof item === 'string' && 
          item.trim() !== '' && 
          item !== '[]' &&
          item !== 'null' &&
          item !== 'undefined'
        )
      }
      
      const validBanners = filterValidUrls(result.banners)
      const validLinks = filterValidUrls(result.links)
      const validAd = filterValidUrls(result.ad)
      const validAdLinks = filterValidUrls(result.adlinks)
      
      console.log('📊 Fetched demographics data:')
      console.log('Banners:', validBanners)
      console.log('Links:', validLinks)
      console.log('Ad images:', validAd)
      console.log('Ad links:', validAdLinks)
      
      setOldBannerImagesUrls(validBanners)
      setLinks(validLinks)
      
      // Convert ad images and links to paired structure
      const adImagesWithLinks = validAd.map((image, index) => ({
        image,
        link: validAdLinks[index] || ''
      }))
      setOldAdImagesData(adImagesWithLinks)
      setAboutUs(result.aboutUs)
      setPrivacyPolicy(result.privacyPolicy)
      setTermsAndConditions(result.termsAndConditions)
      setPhoneNo(result.phoneNo ? result.phoneNo.toString() : '')
      setEmail(result.email)
      setFacebookLink(result.facebookLink)
      setWhatsappLink(result.whatsappLink)
      setInstagramLink(result.instagramLink)
    } else {
      Alert.error(fetchDemographics.message)
    }

    setLoading(false)
    processing.current = false
  }, [])

  useEffect(() => {
    getDemographics()
  }, [getDemographics])

  const discardAll = () => {
    if (bannerImagesUrls.length) {
      bannerImagesUrls.forEach(imageUrl => {
        URL.revokeObjectURL(imageUrl)
      })
    }
    setBannerImages([])
    setBannerImagesUrls([])
    setOldBannerImagesUrls([])
    setOldBannerImagesRemoved([])
    setAdImages([])
    setAdImagesData([])
    setOldAdImagesData([])
    setOldAdImagesRemoved([])
    setLinks([])
    setAboutUs('')
    setPrivacyPolicy('')
    setTermsAndConditions('')
    setPhoneNo('')
    setEmail('')
    setFacebookLink('')
    setWhatsappLink('')
    setInstagramLink('')
  }

  const saveHandler = async () => {
    if (phoneNo && phoneNo.length !== 10) {
      Alert.warn('Invalid Contact Number!')
      return
    }

    if (processing.current) return
    processing.current = true

    const data = new FormData()

    Alert.success('Saving Demographics info...')
    setLoading(true)
    setLoadingStatus('Saving...')

    data.append('links', JSON.stringify(links))
    
    // Extract ad images and links separately for backend compatibility
    const adImagesUrls = oldAdImagesData.map(item => item.image)
    const adLinksUrls = oldAdImagesData.map(item => item.link || '')
    
    data.append('adlinks', JSON.stringify(adLinksUrls))
    data.append('banners', JSON.stringify(oldBannerImagesUrls))
    data.append('oldBannersRemoved', JSON.stringify(oldBannerImagesRemoved))
    data.append('ad', JSON.stringify(adImagesUrls))
    data.append('oldAdsRemoved', JSON.stringify(oldAdImagesRemoved))
    data.append('aboutUs', aboutUs)
    data.append('privacyPolicy', privacyPolicy)
    data.append('termsAndConditions', termsAndConditions)
    data.append('phoneNo', phoneNo)
    data.append('email', email)
    data.append('instagramLink', instagramLink)
    data.append('facebookLink', facebookLink)
    data.append('whatsappLink', whatsappLink)

    // Debug: Log before appending files
    console.log('Banner images to upload:', bannerImages.length)
    console.log('Ad images to upload:', adImages.length)
    
    // Append banner images with 'banners' field name
    bannerImages.forEach((image, index) => {
      console.log(`Appending banner image ${index}:`, image.name)
      data.append('banners', image)
    })
    
    // Extract links for new ad images in order
    const newAdImageLinks = adImagesData.map(item => item.link || '')
    data.append('newAdImageLinks', JSON.stringify(newAdImageLinks))
    
    // Append ad images with 'adImages' field name
    adImages.forEach((image, index) => {
      console.log(`Appending ad image ${index}:`, image.name)
      data.append('adImages', image)
    })

    // Debug: Log all FormData entries
    for (let [key, val] of data.entries()) {
      console.log('FormData field:', key, val.name || val)
    }

    const saveDemographics = await api.admin.demographics.update(data)

    if (saveDemographics.code === 201) {
      if (bannerImages.length) {
        for (let i = 0; i < bannerImagesUrls.length; i++) {
          URL.revokeObjectURL(bannerImagesUrls[i])
        }
      }

      window.location.reload()
    } else {
      Alert.error(saveDemographics.message)
    }

    setLoading(false)
    processing.current = false
  }

  const addLink = () => {
    let newLink = link
    if (newLink) {
      try {
        new URL(newLink)
      } catch (error) {
        Alert.warn('Enter Valid Link!')
        setLink('')
        return
      }

      let isValidLink = new URLSearchParams(new URL(newLink).search).get('v')
      if (!isValidLink) {
        if (link.includes('youtu.be')) {
          // Convert youtu.be link to www.youtube.com/watch?v= format
          isValidLink = link.split('/').pop().split('?')[0]
          newLink = `https://www.youtube.com/watch?v=${isValidLink}`
          setLink(newLink)
        } else {
          Alert.warn('Enter Valid Link!')
          setLink('')
          return
        }
      }

      let newLinks = [...links]
      const isLinkAlreadyExists = newLinks.some(
        youtubeLink =>
          new URLSearchParams(new URL(youtubeLink).search).get('v') ===
          new URLSearchParams(new URL(newLink).search).get('v')
      )
      if (!isLinkAlreadyExists) {
        newLinks.push(newLink)
        setLinks(newLinks)
        setLink('')
      } else {
        Alert.warn('Link Already Exists!')
      }
    }
  }



  return (
  <div className={s.main}>
    <div className={s.demographics}>
      <Layouts.Classic title='Dashboard'>
        <div className={s.headerBottom}>
          <Link className={s.addTestimonies} to={'./blog'}>
          <span className='material-icons-outlined'>add_circle_outline</span> Blog
          </Link>
          <Link className={s.addTestimonies} to={'./news'}>
          <span className='material-icons-outlined'>add_circle_outline</span> News
          </Link>
          <Link className={s.addTestimonies} to={'./success-stories'}>
            <span className='material-icons-outlined'>add_circle_outline</span> Success Stories
          </Link>
          <Link className={s.addFaq} to={'./faq'}>
            <span className='material-icons-outlined'>add_circle_outline</span> Faq's
          </Link>
          <Link className={s.addTestimonies} to={'./partners'}>
            <span className='material-icons-outlined'>add_circle_outline</span> Partners
          </Link>
          <Link className={s.addTestimonies} to={'./featured-placements'}>
            <span className='material-icons-outlined'>add_circle_outline</span> Featured Placements
          </Link>
          <Link className={s.addTestimonies} to={'./auth-pages'}>
            <span className='material-icons-outlined'>add_circle_outline</span> Login & Register Pages
          </Link>
        </div>
      </Layouts.Classic>
      {!loading && (
        <div className={s.content + ' innerScrollX'}>
          <DashBoardNav />

          {/* Banner Upload */}
          <div className={s.banners}>
            <UploadImages.Multiple
              label='Upload Banners'
              inputId='bannerImageUpload'
              listingImagesUrls={bannerImagesUrls}
              oldListingImagesUrls={oldBannerImagesUrls}
              handleListingImagesChange={handleBannerImagesChange}
              handleRemoveImage={handleRemoveBannerImage}
              handleRemoveOldImage={handleRemoveOldBannerImage}
              max={6}
            />
          </div>

          {/* Ad Upload */}
          <div className={s.banners}>
            <UploadImages.Multiple
              label='Upload Ad Images'
              inputId='adImageUpload'
              listingImagesUrls={adImagesData.map(item => item.imageUrl)}
              oldListingImagesUrls={oldAdImagesData.map(item => item.image)}
              handleListingImagesChange={handleAdImagesChange}
              handleRemoveImage={handleRemoveAdImage}
              handleRemoveOldImage={handleRemoveOldAdImage}
              max={6}
            />
          </div>
          
          {/* Ad Image Links Input */}
          {(adImagesData.length > 0 || oldAdImagesData.length > 0) && (
            <div className={s.adImageLinksSection}>
              <div className={s.linksHeading}>Ad Image Links</div>
              <div className={s.adImageLinksContainer}>
                {oldAdImagesData.map((item, i) => (
                  <div key={`old-link-${i}`} className={s.adImageLinkItem}>
                    <div className={s.adImagePreview}>
                      <ImageTag src={item.image} alt={`Ad ${i + 1}`} />
                    </div>
                    <Input.Classic
                      label={`Link for Ad Image ${i + 1}`}
                      type='text'
                      iconLeft='link'
                      placeholder='Enter link URL (optional)'
                      value={item.link || ''}
                      onChange={e => handleOldAdImageLinkChange(i, e.target.value)}
                    />
                  </div>
                ))}
                {adImagesData.map((item, i) => (
                  <div key={`new-link-${i}`} className={s.adImageLinkItem}>
                    <div className={s.adImagePreview}>
                      <ImageTag src={item.imageUrl} alt={`Ad ${oldAdImagesData.length + i + 1}`} />
                    </div>
                    <Input.Classic
                      label={`Link for Ad Image ${oldAdImagesData.length + i + 1}`}
                      type='text'
                      iconLeft='link'
                      placeholder='Enter link URL (optional)'
                      value={item.link || ''}
                      onChange={e => handleAdImageLinkChange(i, e.target.value)}
                    />
                  </div>
                ))}
              </div>
            </div>
          )}

          {!!isUploading && (
            <Loader
              message={uploadingProgress + '% uploaded'}
              color='var(--c-primary)'
              colorText='var(--c-primary)'
            />
          )}

          {/* YouTube Link Input */}
          <Input.Classic
            label='Upload Youtube Link'
            type='text'
            iconLeft='link'
            iconRight='add_circle_outline'
            onRightIconClick={addLink}
            placeholder='Enter Youtube Link'
            value={link}
            onChange={e => setLink(e.target.value)}
            onKeyDown={e => {
              if (e.key === 'Enter' && e.target.tagName !== 'TEXTAREA') {
                e.preventDefault()
                addLink()
              }
            }}
          />

          {links.length > 0 && (
            <div className={s.links}>
              <div className={s.linksHeading}>Links</div>
              <div className={s.addedLinks}>
                {links.filter(link => link && link.trim() !== '').map((link, i) => {
                  try {
                    const videoId = new URLSearchParams(new URL(link).search).get('v')
                    if (!videoId) return null
                    
                    return (
                      <div className={s.link} key={i}>
                        <ImageTag
                          src={`https://img.youtube.com/vi/${videoId}/hqdefault.jpg`}
                          alt=''
                        />
                        <span
                          className='material-icons-outlined'
                          onClick={() => setLinks(links.filter(x => x !== link))}
                        >
                          close
                        </span>
                      </div>
                    )
                  } catch (error) {
                    console.error('Invalid link:', link, error)
                    return null
                  }
                })}
              </div>
            </div>
          )}

          {/* Display Uploaded Ad Images with Links */}
          {(adImagesData.length > 0 || oldAdImagesData.length > 0) && (
            <div className={s.links}>
              <div className={s.linksHeading}>Ad Images Preview</div>
              <div className={s.addedLinks}>
                {oldAdImagesData.map((item, i) => (
                  <div className={s.link} key={`old-${i}`}>
                    {item.link ? (
                      <a
                        href={item.link}
                        target='_blank'
                        rel='noopener noreferrer'
                        style={{ display: 'block', cursor: 'pointer' }}
                      >
                        <ImageTag
                          src={item.image}
                          alt='Ad Image'
                        />
                      </a>
                    ) : (
                      <ImageTag
                        src={item.image}
                        alt='Ad Image'
                      />
                    )}
                    <span
                      className='material-icons-outlined'
                      onClick={() => handleRemoveOldAdImage(i)}
                    >
                      close
                    </span>
                  </div>
                ))}
                {adImagesData.map((item, i) => (
                  <div className={s.link} key={`new-${i}`}>
                    {item.link ? (
                      <a
                        href={item.link}
                        target='_blank'
                        rel='noopener noreferrer'
                        style={{ display: 'block', cursor: 'pointer' }}
                      >
                        <ImageTag
                          src={item.imageUrl}
                          alt='Ad Image'
                        />
                      </a>
                    ) : (
                      <ImageTag
                        src={item.imageUrl}
                        alt='Ad Image'
                      />
                    )}
                    <span
                      className='material-icons-outlined'
                      onClick={() => handleRemoveAdImage(i)}
                    >
                      close
                    </span>
                  </div>
                ))}
              </div>
            </div>
          )}

          {/* Text Fields */}
          <TextArea.Classic
            label='About Us (Max. 1000 words)'
            iconLeft='description'
            placeholder='Enter About Us...'
            value={aboutUs}
            rows='10'
            onChange={e => {
              if (e.target.value.trim().split(/\s+/).length <= 1000) setAboutUs(e.target.value)
            }}
          />
          <TextArea.Classic
            label='Privacy Policy (Max. 1000 words)'
            iconLeft='description'
            placeholder='Enter Privacy Policy...'
            value={privacyPolicy}
            rows='10'
            onChange={e => {
              if (e.target.value.trim().split(/\s+/).length <= 1000) setPrivacyPolicy(e.target.value)
            }}
          />
          <TextArea.Classic
            label='Terms & Conditions (Max. 1000 words)'
            iconLeft='description'
            placeholder='Enter Terms & Conditions...'
            value={termsAndConditions}
            rows='10'
            onChange={e => {
              if (e.target.value.trim().split(/\s+/).length <= 1000) setTermsAndConditions(e.target.value)
            }}
          />

          {/* Contact Info */}
          <div className={s.websiteContact}>
            <div className={s.label}>Contact Us</div>
            <Input.Classic
              label='Contact Number*'
              type='number'
              iconLeft='call'
              placeholder='Enter Contact Number'
              value={phoneNo}
              onChange={e => {
                if (e.target.value.length <= 10) setPhoneNo(e.target.value)
              }}
            />
            <Input.Classic
              label='Email*'
              type='text'
              iconLeft='email'
              placeholder='Enter Email'
              value={email}
              onChange={e => setEmail(e.target.value)}
            />
          </div>

          {/* Socials */}
          <div className={s.websiteSocials}>
            <div className={s.label}>Socials</div>
            <Input.Classic
              label='Instagram Link'
              type='text'
              iconLeft='link'
              placeholder='Enter Instagram Link'
              value={instagramLink}
              onChange={e => setInstagramLink(e.target.value)}
            />
            <Input.Classic
              label='Facebook Link'
              type='text'
              iconLeft='link'
              placeholder='Enter Facebook Link'
              value={facebookLink}
              onChange={e => setFacebookLink(e.target.value)}
            />
            <Input.Classic
              label='Whatsapp Link'
              type='text'
              iconLeft='link'
              placeholder='Enter Whatsapp Link'
              value={whatsappLink}
              onChange={e => setWhatsappLink(e.target.value)}
            />
          </div>

          {/* Action Buttons */}
          <div className={s.actionButtons}>
            <div className={s.discard} onClick={discardAll}>
              <span className='material-icons-outlined'>remove_circle_outline</span>Discard
            </div>
            <div className={s.saveHandler} onClick={saveHandler}>
              <span className='material-icons-outlined'>save</span>Save
            </div>
          </div>
        </div>
      )}
      {!!loading && (
        <div className={s.loader}>
          <Loader message={loadingStatus} color='var(--c-primary)' colorText='var(--c-primary)' />
        </div>
      )}
    </div>
  </div>
)

}


  // return (
  //   <div className={s.main}>
  //     <div className={s.demographics}>
  //       <Layouts.Classic title='Dashboard'>
  //         <div className={s.headerBottom}>
  //           <Link className={s.addTestimonies} to={'./testimonies'}>
  //             <span className='material-icons-outlined'>add_circle_outline</span> Testimonies
  //           </Link>
  //           <Link className={s.addFaq} to={'./faq'}>
  //             <span className='material-icons-outlined'>add_circle_outline</span> Faq's
  //           </Link>
  //         </div>
  //       </Layouts.Classic>
  //       {!loading && (
  //         <div className={s.content + ' innerScrollX'}>
  //           <DashBoardNav />
  //           <div className={s.banners}>
  //             <UploadImages.Multiple
  //               label='Upload Banners'
  //               listingImagesUrls={bannerImagesUrls}
  //               oldListingImagesUrls={oldBannerImagesUrls}
  //               handleListingImagesChange={handleBannerImagesChange}
  //               handleRemoveImage={handleRemoveBannerImage}
  //               handleRemoveOldImage={handleRemoveOldBannerImage}
  //               max={6}
  //             />
  //             {!!isUploading && (
  //               <Loader
  //                 message={uploadingProgress + '% uploaded'}
  //                 color='var(--c-primary)'
  //                 colorText='var(--c-primary)'
  //               />
  //             )}
  //           </div>
  //           <Input.Classic
  //             label='Upload Youtube Link'
  //             type='text'
  //             iconLeft='link'
  //             iconRight='add_circle_outline'
  //             onRightIconClick={addLink}
  //             placeholder='Enter Youtube Link'
  //             value={link}
  //             onChange={e => setLink(e.target.value)}
  //             onKeyDown={e => {
  //               if (e.key === 'Enter') {
  //                 if (e.target.tagName !== 'TEXTAREA') {
  //                   e.preventDefault()
  //                   addLink()
  //                 }
  //               }
  //             }}
  //           />
  //           {links.length !== 0 && (
  //             <div className={s.links}>
  //               <div className={s.linksHeading}>Links</div>
  //               <div className={s.addedLinks}>
  //                 {links.map((link, i) => (
  //                   <div className={s.link} key={i}>
  //                     <ImageTag
  //                       src={`https://img.youtube.com/vi/${new URLSearchParams(new URL(link).search).get(
  //                         'v'
  //                       )}/hqdefault.jpg`}
  //                       alt=''
  //                     />
  //                     <span className='material-icons-outlined' onClick={() => setLinks(links.filter(x => x !== link))}>
  //                       close
  //                     </span>
  //                   </div>
  //                 ))}
  //               </div>
  //             </div>
  //           )}
  //           <TextArea.Classic
  //             label='About Us (Max. 1000 words)'
  //             iconLeft='description'
  //             placeholder='Enter About Us...'
  //             value={aboutUs}
  //             rows='10'
  //             onChange={e => {
  //               if (e.target.value.trim().split(/\s+/).length <= 1000) setAboutUs(e.target.value)
  //             }}
  //           />
  //           <TextArea.Classic
  //             label='Privacy Policy (Max. 1000 words)'
  //             iconLeft='description'
  //             placeholder='Enter Privacy Policy...'
  //             value={privacyPolicy}
  //             rows='10'
  //             onChange={e => {
  //               if (e.target.value.trim().split(/\s+/).length <= 1000) setPrivacyPolicy(e.target.value)
  //             }}
  //           />
  //           <TextArea.Classic
  //             label='Terms & Conditions (Max. 1000 words)'
  //             iconLeft='description'
  //             placeholder='Enter Terms & Conditions...'
  //             value={termsAndConditions}
  //             rows='10'
  //             onChange={e => {
  //               if (e.target.value.trim().split(/\s+/).length <= 1000) setTermsAndConditions(e.target.value)
  //             }}
  //           />
  //           <div className={s.websiteContact}>
  //             <div className={s.label}>Contact Us</div>
  //             <Input.Classic
  //               label='Contact Number*'
  //               type='number'
  //               iconLeft='call'
  //               placeholder='Enter Contact Number'
  //               value={phoneNo}
  //               onChange={e => {
  //                 if (e.target.value.length <= 10) setPhoneNo(e.target.value)
  //               }}
  //             />
  //             <Input.Classic
  //               label='Email*'
  //               type='text'
  //               iconLeft='email'
  //               placeholder='Enter Email'
  //               value={email}
  //               onChange={e => {
  //                 setEmail(e.target.value)
  //               }}
  //             />
  //           </div>
  //           <div className={s.websiteSocials}>
  //             <div className={s.label}>Socials</div>
  //             <Input.Classic
  //               label='Instagram Link'
  //               type='text'
  //               iconLeft='link'
  //               placeholder='Enter Instagram Link'
  //               value={instagramLink}
  //               onChange={e => {
  //                 setInstagramLink(e.target.value)
  //               }}
  //             />
  //             <Input.Classic
  //               label='Facebook Link'
  //               type='text'
  //               iconLeft='link'
  //               placeholder='Enter Facebook Link'
  //               value={facebookLink}
  //               onChange={e => {
  //                 setFacebookLink(e.target.value)
  //               }}
  //             />
  //             <Input.Classic
  //               label='Whatsapp Link'
  //               type='text'
  //               iconLeft='link'
  //               placeholder='Enter Whatsapp Link'
  //               value={whatsappLink}
  //               onChange={e => {
  //                 setWhatsappLink(e.target.value)
  //               }}
  //             />
  //           </div>

  //           <div className={s.actionButtons}>
  //             <div className={s.discard} onClick={discardAll}>
  //               <span className='material-icons-outlined'>remove_circle_outline</span>Discard
  //             </div>
  //             <div className={s.saveHandler} onClick={saveHandler}>
  //               <span className='material-icons-outlined'>save</span>Save
  //             </div>
  //           </div>
  //         </div>
  //       )}
  //       {!!loading && (
  //         <div className={s.loader}>
  //           <Loader message={loadingStatus} color='var(--c-primary)' colorText='var(--c-primary)' />
  //         </div>
  //       )}
  //     </div>
  //   </div>
  // )